import * as React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { Col, Row, Glyphicon } from "react-bootstrap";
import { Form } from "react-final-form";
import { DotLoader } from "react-spinners";
import { REQUEST } from "src/co/sura/config/ajax-wrapper";
import { Mensaje } from "../../../general/componentes/Mensaje";
import DatePickerSura from "../../../general/componentes/DatePicker";
import TextoAyuda from "../../config_general/componentes/TextoAyuda";
import { fechaFinalEmpresasTrasladadas, fechaInicialEmpresasTrasladadas } from "../../config_general/modelo/TextosAyuda";
import { consultarSAT, limpiarMensajes, descargarConsultaSATXLS } from "../modulos/iniciFinRelacionLaboralActions";

class InicioFinRelacionLaboral extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
    }

    componentWillUnmount() {
        const { datosEmpresas } = this.props;
        if (!datosEmpresas || !datosEmpresas.length) this.props.dispatch(limpiarMensajes());
    }

    render() {
        return (
            <div>
                <Row>
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Inicio/Fin Relación Laboral</h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Buscar reporte con rango de fecha</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label>Fecha Inicial consulta</label>
                                                <TextoAyuda texto={fechaInicialEmpresasTrasladadas} />
                                                <DatePickerSura name={"fechaInicial"} />
                                            </Col>
                                            <Col sm={3}>
                                                <label>Fecha Final consulta</label>
                                                <TextoAyuda texto={fechaFinalEmpresasTrasladadas} />
                                                <DatePickerSura name={"fechaFinal"} />
                                            </Col>
                                        </Row>
                                        <div style={{ marginTop: `25px` }}>
                                            <Row className={"form-group"}>
                                                <Col sm={2}>
                                                    {
                                                        (this.props.jsonRespuesta) &&
                                                        <a className="btns btn-success" onClick={() => this.descargarXLS()}>
                                                            <b>Exportar XLSX</b> &nbsp;<Glyphicon className={"download-alt"} glyph={"download-alt"} />
                                                        </a>
                                                    }
                                                </Col>
                                                <Col smOffset={6} sm={1}>
                                                    <button type="button" className="btns btns-link" onClick={form.reset}
                                                        disabled={submitting || pristine}>
                                                        Limpiar
                                                    </button>
                                                </Col>
                                                <Col sm={2}>
                                                    <button type="submit" className="btns btns-primary" disabled={submitting || invalid}>
                                                        <b>Consultar</b> &nbsp;<Glyphicon className={"search"} glyph={"search"} />
                                                    </button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </Row>
                <Row>
                    {this.renderPestañaRespuestaJson()}
                </Row>
            </div>
        );
    }

    renderPestañaRespuestaJson() {
        const { estadoConsulta, jsonRespuesta } = this.props;

        switch (estadoConsulta) {
            case REQUEST.ERROR:
                return (null);
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                    </div>
                );
            case REQUEST.SUCCESS:
                if (jsonRespuesta)
                    return (
                        <span>
                            <Mensaje type={"success"} mensaje={'La consulta se encuentra en tramite '} />
                        </span>
                    );
                else
                    return (
                        <span>
                            <Mensaje type={"warning"} mensaje='La información retornada por SAT excede el límite establecido
                                de la consulta, para visualizar los demás registros se debe cerrar el rango de fechas.' />
                        </span>
                    );
            default:
                return false;
        }
    }

    validate = (values: any) => {
        const errors = {
            fechaInicial: undefined,
            fechaFinal: undefined
        };


        if (!values.fechaInicial)
            errors.fechaInicial = "Por favor seleccione la fecha incial";

        if (values.fechaInicial && !values.fechaFinal)
            errors.fechaFinal = "Por favor seleccione la fecha final";

        if (values.fechaInicial && values.fechaFinal && values.fechaInicial.isAfter(values.fechaFinal)) {
            errors.fechaFinal = "La fecha final no puede ser anterior a la fecha inicial";
        }

        return errors;
    };

    onSubmit = (values: any) => {
        const fechaInicial = values.fechaInicial ? values.fechaInicial.format("YYYY-MM-DD").valueOf() : "";
        const fechaFinal = values.fechaFinal ? values.fechaFinal.format("YYYY-MM-DD").valueOf() : "";

        const jsonConsulta = {
            "FechaInicio": fechaInicial,
            "FechaFin": fechaFinal
        };

        this.setState({
            fechaInicial: fechaInicial,
            fechaFinal: fechaFinal
        });

        this.props.dispatch(consultarSAT(JSON.stringify(jsonConsulta)));
    };

    descargarXLS() {
        if (this.props.jsonRespuesta) {
            const jsonConsulta = {
                "FechaInicio": this.state.fechaInicial,
                "FechaFin": this.state.fechaFinal
            };
            this.props.dispatch(descargarConsultaSATXLS(JSON.stringify(jsonConsulta)));
        }
    }
}

export default connect((store: any) => {
    return {
        dniUsuarioGestionLogin: R.pathOr(undefined, ["inicio", "dniLogin"])(store),
        estadoConsulta: R.pathOr([], ["inicio_Fin_Relacion_laboral", "estadoConsulta"])(store),
        estadoDescarga: R.pathOr([], ["inicio_Fin_Relacion_laboral", "estadoDescarga"])(store),
        jsonRespuesta: R.pathOr(undefined, ["inicio_Fin_Relacion_laboral", "jsonRespuesta"])(store),
        mensajeUsuario: R.pathOr(undefined, ["inicio_Fin_Relacion_laboral", "mensajeUsuario"])(store)
    };
})(InicioFinRelacionLaboral);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/inicio_fin_relacion_laboral/componentes/InicioFinRelacionLaboral.tsx